export default __webpack_public_path__ + "static/media/mechanism.8ba18be9.svg";